import { useMutation, gql } from 'urql';

export const DELETE_SMINEX_CLUB_CLIENT_MUTATION = gql`
  mutation DeleteSminexClubClient($clientId: Int!) {
    deleteSminexClubClient(clientId: $clientId) {
      success
      rowsAffected
    }
  }
`;

export interface DeleteSminexClubClientVariables {
  clientId: number;
}

export interface DeleteSminexClubClientResponse {
  deleteSminexClubClient: {
    success: boolean;
    rowsAffected: number;
  };
}

export const useDeleteSminexClubClient = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<
    DeleteSminexClubClientResponse,
    DeleteSminexClubClientVariables
  >(DELETE_SMINEX_CLUB_CLIENT_MUTATION);

  const deleteSminexClubClient = (clientId: number) => {
    return executeMutation({ clientId });
  };

  return { data, error, fetching, deleteSminexClubClient };
};
